/**
 * Alert
 */
import clsx from 'clsx';
import React from 'react';
import { Icon } from 'ui-component-library/base';
/** Main description for this component. */
var Alert = function (_a) {
    var className = _a.className, variant = _a.variant, onClick = _a.onClick, icon = _a.icon, children = _a.children;
    var IconType;
    (function (IconType) {
        IconType["info"] = "iconInfo";
        IconType["success"] = "check";
        IconType["warning"] = "iconAlertTriangle";
        IconType["danger"] = "iconAlertTriangle";
    })(IconType || (IconType = {}));
    var iconColors;
    switch (variant) {
        case 'info':
            iconColors = '#2B7BDE';
            break;
        case 'success':
            iconColors = '#008A2B';
            break;
        case 'warning':
            iconColors = '#E05B27';
            break;
        case 'danger':
            iconColors = '#E0182D';
            break;
    }
    return (React.createElement("div", { "data-cid": "AlertBox", className: clsx(className, 'bg-white') },
        React.createElement("div", { className: clsx('rounded border-2 flex py-2 px-3 items-baseline justify-between', variant === 'info' && 'alert--info', variant === 'success' && 'alert--success', variant === 'warning' && 'alert--warning', variant === 'danger' && 'alert--danger') },
            React.createElement("div", { className: "flex" },
                React.createElement("span", null,
                    React.createElement(Icon, { icon: icon || IconType[variant], color: iconColors, className: "flex-shrink-0 mr-3" })),
                React.createElement("div", { className: "inline-block" }, children)),
            onClick && (React.createElement("button", { onClick: onClick, className: "ml-3" },
                React.createElement("span", { className: "sr-only" }, "St\u00E4ng"),
                React.createElement("span", null,
                    React.createElement(Icon, { icon: "close", color: "#79766F" })))))));
};
export default Alert;
